import { Identity } from "hooks/useIdentity";
import { sessionStorageUtility } from "utils/storage";

export function useStorageIdentity() {

    const key = "dt-cm-identityToken";

    return {
        getIdentity,
        setIdentity
    };

    function getIdentity() {
        const itemString = sessionStorageUtility.getItem(key);

        if (!itemString)
            return null;

        const item = JSON.parse(itemString);

        const tokenExpiry = item?.decodedV2?.expiresAt || (item.decodedV2.exp * 1000);

        if (new Date(tokenExpiry) >= new Date(Date.now()))
            return item as Identity;

        return null;
    }

    function setIdentity(token: Identity) {
        sessionStorageUtility.setItem(key, JSON.stringify(token));
    }
}